import React from 'react';
import { ArrowDownToLine, Loader2, Upload, X } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Card } from '../../../ui/card';
import { Input } from '../../../ui/input';
import { Textarea } from '../../../ui/textarea';

const WebinarImportModal = ({
  open,
  onClose,
  webinarImportKey,
  setWebinarImportKey,
  webinarImportCsv,
  setWebinarImportCsv,
  onFileChange,
  onSubmit,
  webinarImporting,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-black/50 p-4">
      <div className="flex min-h-full items-start justify-center pt-8">
        <Card className="max-h-[calc(100vh-4rem)] w-full max-w-2xl overflow-y-auto border-[#2a2a32] bg-[#1e1e24] p-6">
          <div className="mb-4 flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-white">Import Webinar Results</h3>
              <p className="mt-1 text-sm text-gray-400">
                Paste the Luma guest CSV after the webinar. We will update dads by email, split attended vs missed, and create the follow-up campaigns once per webinar key.
              </p>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-white">
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <label className="text-sm text-gray-400">Webinar import key</label>
              <Input
                value={webinarImportKey}
                onChange={(e) => setWebinarImportKey(e.target.value)}
                placeholder="dad_partners_founding_forty_webinar_2026_03_29"
                className="mt-1 border-[#2a2a32] bg-[#16161a] text-white"
              />
            </div>
            <div>
              <label className="text-sm text-gray-400">Note</label>
              <div className="mt-1 rounded-lg border border-[#2a2a32] bg-[#16161a] px-3 py-2 text-xs text-gray-400">
                Re-importing the same webinar key will update dads by email without creating duplicate follow-up campaigns.
              </div>
            </div>
          </div>

          <div className="mt-4">
            <label className="mb-2 block text-sm text-gray-400">CSV content</label>
            <div className="mb-3 flex flex-wrap items-center gap-3">
              <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-[#2a2a32] bg-[#16161a] px-3 py-2 text-sm text-white hover:bg-[#202028]">
                <Upload className="h-4 w-4" />
                Load CSV file
                <input type="file" accept=".csv,text/csv" className="hidden" onChange={onFileChange} />
              </label>
              <span className="text-xs text-gray-500">
                Expected columns: email, name, phone number, has joined event, custom source, plus any extra Luma registration answers.
              </span>
            </div>
            <Textarea
              value={webinarImportCsv}
              onChange={(e) => setWebinarImportCsv(e.target.value)}
              placeholder="Paste the webinar results CSV here..."
              className="min-h-[260px] border-[#2a2a32] bg-[#16161a] font-mono text-xs text-white"
            />
          </div>

          <div className="flex gap-3 pt-5">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1 border-[#2a2a32] text-white hover:bg-[#16161a]"
            >
              Cancel
            </Button>
            <Button
              onClick={onSubmit}
              disabled={webinarImporting || !webinarImportCsv.trim() || !webinarImportKey.trim()}
              className="flex-1 gap-2 bg-aqua text-charcoal hover:bg-aqua-dark"
            >
              {webinarImporting ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowDownToLine className="h-4 w-4" />}
              Import Webinar Results
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default WebinarImportModal;
